import styled from 'styled-components/macro';
import { StylePropsComplex } from './svg';

export const Wrapper = styled.div.attrs({
  className: 'svg-viewer',
})<{ props?: StylePropsComplex }>`
  width: ${(props) => (props?.props?.size ? props.props.size : '16px')};
  height: ${(props) => (props?.props?.size ? props.props.size : '16px')};
  rotate: ${(props) => (props?.props?.deg ? props?.props?.deg : 0)}deg;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) =>
    props?.props?.cursor ? props?.props?.cursor : 'default'};

  transform: ${(props) => (props?.props?.isMirror ? 'rotate(-180deg)' : 'none')};
  transition: all 150ms;

  & svg {
    & > path,
    & > circle {
      fill: ${(props) =>
        !!props?.props?.color
          ? props.props.color === 'inherit'
            ? 'currentColor'
            : props.props.color
          : ''};
    }
  }

  &:hover {
    & > svg > path,
    & > svg > circle {
      fill: ${(props) =>
        props?.props?.hoverColor ? props?.props?.hoverColor : ''};
    }
  }
`;

export const ComplexWrapper = styled.div.attrs({
  className: 'complex-svg__wrapper',
})<{ props?: StylePropsComplex }>`
  width: ${(props) => (props?.props?.size ? props.props.size : '16px')};
  height: ${(props) => (props?.props?.size ? props.props.size : '16px')};
  rotate: ${(props) => (props?.props?.deg ? props?.props?.deg : 0)}deg;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) =>
    props?.props?.cursor ? props?.props?.cursor : 'default'};

  transform: ${(props) => (props?.props?.isMirror ? 'rotate(180deg)' : 'none')};

  & svg > g {
    & > path,
    & > circle {
      fill: ${(props) =>
        !!props?.props?.color
          ? props.props.color === 'inherit'
            ? 'currentColor'
            : props.props.color
          : ''};

      &:last-child {
        fill: ${(props) =>
          !!props?.props?.subColor
            ? props.props.subColor === 'inherit'
              ? 'currentColor'
              : props.props.subColor
            : ''};
      }
    }
  }

  &:hover {
    & > svg > g > path,
    & > svg > g > circle {
      fill: ${(props) =>
        props?.props?.hoverColor ? props?.props?.hoverColor : ''};

      &:last-child {
        fill: ${(props) =>
          props?.props?.subHoverColor ? props?.props?.subHoverColor : ''};
      }
    }
  }
`;
